export enum Language {
    EN = 'en',
    DE = 'de',
    RU = 'ru',
}
